import uniqBy from 'lodash/uniqBy';
import accepts from 'attr-accept';
import getMimeTypeDescription from './getMimeTypeDescription';

export const fileAccepted = (file, accept) => {
  return file.type === 'application/x-moz-file' || accepts(file, accept);
};

export const getFileName = file => file.pk.split('/').slice(-1)[0];

export const getLabel = (files, inputProps) => {
  const mimetypeOptions = getMimeTypeDescription(inputProps.accept);

  if (!inputProps.multiple) {
    if (files.length && mimetypeOptions) {
      return `choose a different ${mimetypeOptions}\u00A0file`;
    }

    if (!files.length && mimetypeOptions) {
      return `choose a ${mimetypeOptions}\u00A0file`;
    }

    if (files.length) {
      return 'choose a different file';
    }

    return 'choose a file';
  }

  if (files.length && mimetypeOptions) {
    return `choose additional ${mimetypeOptions}\u00A0files`;
  }

  if (!files.length && mimetypeOptions) {
    return `choose ${mimetypeOptions}\u00A0files`;
  }

  if (files.length) {
    return 'choose additional files';
  }

  return `choose files`;
};

export const getUpdateFiles = (files, newFiles, inputProps) => {
  const { multiple, accept } = inputProps;
  if (multiple) {
    const uniqueFiles = uniqBy([...files, ...newFiles], 'name');
    return uniqueFiles.filter(file => fileAccepted(file, accept));
  }
  const acceptedFiles = [...newFiles].find(file => fileAccepted(file, accept));
  return acceptedFiles ? [acceptedFiles] : [];
};
